// This clears form fields after they are sent using htmx:afterSwap
export function clearFields() {
  // add_rate_set form on Crreate new product
  document.body.addEventListener('htmx:afterSwap', function (event) {
    if (event.target.id === 'rate_set_dropdown') {
      let inputPublicName = document.querySelector('#id_public_name');
      let inputBasePrice = document.querySelector('#id_base_price');
      if (inputPublicName) inputPublicName.value = '';
      if (inputBasePrice) inputBasePrice.value = '';
    }
  });
}
